import { render } from "./HeroSet4.vue?vue&type=template&id=a0c85d3a&scoped=true"
import script from "./HeroSet4.vue?vue&type=script&lang=js"
export * from "./HeroSet4.vue?vue&type=script&lang=js"

import "./HeroSet4.vue?vue&type=style&index=0&id=a0c85d3a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a0c85d3a"

export default script